import * as React from "react";
import { SxProps } from "@mui/material";
import { Box } from "@mui/system";
import { ResourceView } from "@tlc/ls2pac/dto/ResourceView";
import { ResourceDWR } from "@tlc/ls2pac/dto/ResourceDWR";

export interface BookjacketProps {
  id?: string | number;
  resource: ResourceDWR | ResourceView;
  sx?: SxProps;
  size?: JacketSize;
  showFormat?: boolean;
}

export enum JacketSize {
  m = "BOOKJACKET-MD",
  s = "BOOKJACKET-SM",
  xs = "BOOKJACKET-XS",
  lg = "BOOKJACKET-LG",
}

export const Bookjacket: React.FC<BookjacketProps> = ({
  id,
  resource,
  size = JacketSize.s,
  sx = {},
  showFormat = true,
}) => {
  const bookjacketId = `bookjacket_${id ? id : resource.id}`;
  React.useEffect(() => {
    // TODO refactor out the addCoverArt dependency
    $(`#${bookjacketId}`).addCoverArt(
      size,
      [resource],
      0,
      true,
      true,
      () => {},
      showFormat
    );
  }, []);

  return (
    <Box className="imgContainer" sx={sx}>
      <Box id={bookjacketId} className="bookjacket dropShadow"></Box>
    </Box>
  );
};
